import React from "react";
import Photos from "../components/Photos";

const Gallery = () => {
  return <Photos />;
};

export default Gallery;
